/**
 * Teller rate/scale helpers. Teller expresses APR / interest rates as a `uint16`
 * in BASIS POINTS where 10000 = 100% (NumbersLib `PCT_100 = 1e4`), so the
 * interest on a loan is `principal * apr * duration / (365d * 10000)`.
 */

/** uint16 basis points → percent (1000 bps → 10). */
export function tellerBpsToPercent(bps: number | null | undefined): number {
  if (!bps) return 0
  return bps / 100
}

/** raw base units → human number. */
export function tellerToHuman(raw: bigint | null | undefined, decimals: number): number {
  if (!raw) return 0
  return Number(raw) / 10 ** decimals
}

/**
 * Implied max origination LTV of a pool: value of 1 principal token divided by
 * the value of the collateral the pool requires to back it. Note Teller has NO
 * price liquidation — this is the collateral requirement at ORIGINATION, not an
 * ongoing liquidation threshold. Returns 0 when prices or the collateral read
 * are unavailable (informational only).
 */
export function tellerImpliedLtv(
  collateralPerPrincipal: bigint | null | undefined,
  collateralDecimals: number,
  principalPrice: number,
  collateralPrice: number,
): number {
  if (!collateralPerPrincipal || principalPrice <= 0 || collateralPrice <= 0) return 0
  const collHuman = Number(collateralPerPrincipal) / 10 ** collateralDecimals
  const collateralValue = collHuman * collateralPrice
  if (collateralValue <= 0) return 0
  const ltv = principalPrice / collateralValue
  return ltv > 0 && ltv < 1 ? ltv : ltv >= 1 ? 1 : 0
}
